// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"721":"5c7465f7","991":"ea493f1e"}[chunkId] + ".chunk.css";
};